<template>
  <section class="app-section app-section-light container-fluid">
    <!-- Section container -->
    <div class="corp-awards">
      <div class="corp-awards-title">
        <h3 class="section-heading">Award Winning Service</h3>
        <img
          class="center-block"
          src="https://trailfinders.com/codesource/corporate/aws-tp.png"
          alt="Award Winning Service"
        />
      </div>
      <!-- Carousel -->
      <div class="carousel-container">
        <Carousel />
      </div>
    </div>
  </section>
</template>

<script>
import Carousel from '../../components/Carousel'
export default {
  components: {
    Carousel
  },
  mounted() {

    const cid = this.$route.query.cid;
    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        if (cid) {
          console.log('Sending ' + cid)
          window.ga('send', { hitType: 'event', eventCategory: 'qr', eventAction: 'click', eventLabel: cid })
        }
      }
    }
  }
}
</script>

<style scoped>
.carousel-container {
  margin: 100px 0;
  height: 250px;
  overflow: hidden;
}
</style>